<template>
  <li class="office_space_item">
    <router-link :to="_href" target="_blank" class="office_space_item_a">
      <img :src="item.coverPath" />
      <div class="view">{{item.popularity || 0}}浏览</div>
      <router-link
        target="_blank"
        :to="`/investment_info_park_detail?incubator_id=${item.incubator_id}`"
        class="park_name elip"
      >{{item.incubator_name}}</router-link>
      <div class="office">
        <div class="l elip">{{item.name}}</div>
        <div class="r">
          <template v-if="item.money !== ''">
            <span>{{item.money}}</span>
            <template v-if="item.type==='MeetingTypeMeeting'">元/半小时</template>
            <template v-else-if="item.type==='MeetingTypeOffice'">元/间/月</template>
            <template v-else-if="item.type==='MeetingTypeStation'">元/个/月</template>
            <template v-else-if="item.type==='MeetingTypeOther'">元/间/月</template>
          </template>
          <template v-else>
            <span>面议</span>
          </template>
          
        </div>
      </div>
      <h4>
        {{item.area}}m²
        <span>|</span>
        {{item.floor}}
        <span>|</span>
        {{item.direction}}
      </h4>
    </router-link>
  </li>
</template>

<script>
export default {
  props: {
    item: {
      type: Object
    }
  },
  computed: {
    _href() {
      let type = this.item.type;
      let _url = `/office_space_detail?id=${this.item.id}&incubator_id=${this.item.incubator_id}`;
      // if (type === "MeetingTypeMeeting") {
      //   _url = `/office_space_detail?id=${this.item.id}&incubator_id=${this.item.incubator_id}`;
      // } else if (type === "MeetingTypeOffice") {
      //   _url = `/office_space_detail?incubator_id=${this.item.incubator_id}&id=${this.item.id}`;
      // } else if (type === "MeetingTypeStation") {
      //   _url = `/office_space_detail?incubator_id=${this.item.incubator_id}&id=${this.item.id}`;
      // }else if(type === 'MeetingTypeOther'){
      //   _url = `/office_space_detail?incubator_id=${this.item.incubator_id}&id=${this.item.id}`;
      // }
      return _url;
    }
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.office_space_item {
  width: 386px;
  margin: 0 19px 20px 0;
  border-radius: 4px;
  border: 1px solid #eeeeee;
  box-sizing: border-box;
  .office_space_item_a {
    display: flex;
    flex-direction: column;
    position: relative;
    img {
      width: 100%;
      height: 288px;
    }
    .view {
      position: absolute;
      min-width: 60px;
      padding: 7px 7px 5px;
      background: rgba(0, 0, 0, 0.3);
      color: #fff;
      font-size: 12px;
      text-align: center;
      right: 0;
      top: 264px;
    }
    .park_name {
      height: 26px;
      line-height: 26px;
      color: #343434;
      font-size: 14px;
      margin-top: 12px;
      padding: 0 20px;
    }
    .park_name:hover {
      color: #4c84ff;
    }
    .office {
      height: 28px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;
      .l {
        font-size: 16px;
        font-weight: bold;
        color: #343434;
        max-width: 250px;
      }
      .r {
        color: #ff4e5a;

        font-size: 14px;
        span {
          font-size: 18px;

          font-weight: bold;
        }
      }
    }
    & > h4 {
      height: 26px;
      line-height: 26px;
      color: #9a9a9a;
      padding: 0 20px;
      span {
        margin: 0 10px;
      }
    }
  }
}
</style>